import { IAuditionAttributes } from 'shared/interfaces/IAudition';

export const getMainAuditionSchedule = (auditionSchedules: IAuditionAttributes['audition_schedules']) => {
  return auditionSchedules.filter((auditionSchedule) => auditionSchedule.main)[0];
};

export const getLatestAuditionSchedule = (auditionSchedules: IAuditionAttributes['audition_schedules']) => {
  return auditionSchedules.length > 0 ? auditionSchedules[auditionSchedules.length - 1] : null;
};
